export default "__VITE_ASSET__luEuJ7ZE__"